import MainSettings from "../components/settings/main-settings";

function Settings() {
    return(<div><MainSettings/></div>)
}

export default Settings;